import * as React from "react";

import { Box, Preloader } from "@origin-digital/ods-core";

export const PageLoader: React.FunctionComponent = () => (
  <Box justifyContent="center" alignItems="center" display="flex" height="full">
    <Preloader />
  </Box>
);
